"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectDashboardResultByChunks = void 0;
const ICCanisterUtils_1 = require("src/hello_assets/src/util/ICCanisterUtils");
const async_1 = __importDefault(require("async"));
const lodash_1 = __importDefault(require("lodash"));
const ArrayCalculationsFacade_1 = require("src/hello_assets/src/util/ArrayCalculationsFacade");
const AnalyticsStoreRestApi_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/AnalyticsStoreRestApi");
const getNumberOfChunksByLastNDays = (lastNDays) => {
    if (lastNDays >= 180) {
        return 64;
    }
    if (lastNDays >= 90) {
        return 32;
    }
    if (lastNDays >= 60) {
        return 16;
    }
    if (lastNDays >= 30) {
        return 8;
    }
    if (lastNDays >= 15) {
        return 4;
    }
    return 1;
};
const getProjectDashboardResultByChunks = async (actors, accessToken, lastNDays) => {
    return new Promise((resolve) => {
        if (process.env.NODE_ENV === "development") {
            console.log("DashboardApiService.getDashboardResultByChunks!!!! lastNDays", lastNDays);
        }
        const numberOfChunksByLastNDays = getNumberOfChunksByLastNDays(lastNDays);
        if (!!process.env.IS_TEST_SERVER) {
            console.log("getProjectDashboardResultByChunks numberOfChunksByLastNDays", { lastNDays, numberOfChunksByLastNDays });
        }
        const ranges = (0, ICCanisterUtils_1.splitPartitionsCountIntoChunks)(numberOfChunksByLastNDays, ICCanisterUtils_1.USERS_PARTITIONS_COUNT);
        const tasks = lodash_1.default.flatten(lodash_1.default.map(actors, (actor, actorIdx) => {
            return lodash_1.default.flatten(lodash_1.default.map(ranges, (range, rangeIdx) => {
                const cumulativeIdx = ranges.length * actorIdx + rangeIdx;
                return (callback) => {
                    (async () => {
                        try {
                            const result = await AnalyticsStoreRestApi_1.AnalyticsStoreRestApi.getProjectDashboardChunk(actor, accessToken, { lastNDays: lastNDays, partitionsRange: range });
                            const taskResult = { idx: cumulativeIdx, actorIndex: actorIdx, chunk: result };
                            callback(null, taskResult);
                        }
                        catch (e) {
                            callback(e);
                        }
                    })();
                };
            }));
        }));
        async_1.default.parallelLimit(tasks, 10, (err, results) => {
            if (!lodash_1.default.isNil(err)) {
                console.error("getDashboardResultByChunks promises failure: at least one of the chunks failed", err);
                resolve({ err: { "temporarilyUnavailable": null } });
            }
            else {
                if (!!process.env.IS_TEST_SERVER) {
                    console.log("getDashboardResultByChunks promises results", results);
                }
                try {
                    const tasksResult = results;
                    const thereAreErrors = lodash_1.default.some(tasksResult, (taskResult) => {
                        if ((taskResult === null || taskResult === void 0 ? void 0 : taskResult.chunk) == undefined) {
                            return true;
                        }
                        return (0, ICCanisterUtils_1.isICRequestErr)(taskResult.chunk);
                    });
                    if (thereAreErrors) {
                        console.warn("getDashboardResultByChunks promises failure: there are backend errors", tasksResult);
                        resolve({ err: { "temporarilyUnavailable": null } });
                        return;
                    }
                    else {
                        //all chunk errors (by checking "isICRequestErr") made above. So here all variants are "#ok".
                        const dashboardResultDataArray = lodash_1.default.compact(lodash_1.default.map(tasksResult, (taskResult) => {
                            if (taskResult != undefined && (0, ICCanisterUtils_1.isICRequestOk)(taskResult.chunk)) {
                                return {
                                    idx: taskResult.idx,
                                    actorIndex: taskResult.actorIndex,
                                    chunkData: taskResult.chunk.ok
                                };
                            }
                        }));
                        // console.log("getDashboardResultByChunks promises: dashboardResultDataArray", dashboardResultDataArray);
                        if (dashboardResultDataArray.length > 0) {
                            const intervalStartTimeSec = dashboardResultDataArray[0].chunkData.dau.intervalStartTimeSec;
                            /**
                             * WARNING!!!
                             * DAU is not split into chunks on the server!!!
                             * We must sum only one chunk from each actor!!!
                             */
                            const uniqueActorResponsesForDAU = lodash_1.default.uniqBy(dashboardResultDataArray, v => v.actorIndex);
                            // console.log("getDashboardResultByChunks promises: uniqueActorResponsesForDAU", uniqueActorResponsesForDAU);
                            const resultDau = {
                                intervalStartTimeSec: intervalStartTimeSec,
                                data: Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.map(uniqueActorResponsesForDAU, value => Array.from(value.chunkData.dau.data))))
                            };
                            const resultWau = {
                                intervalStartTimeSec: intervalStartTimeSec,
                                data: Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.map(dashboardResultDataArray, value => Array.from(value.chunkData.wau.data))))
                            };
                            const resultMau = {
                                intervalStartTimeSec: intervalStartTimeSec,
                                data: Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.map(dashboardResultDataArray, value => Array.from(value.chunkData.mau.data))))
                            };
                            const resultNewUsers = {
                                intervalStartTimeSec: intervalStartTimeSec,
                                data: Int32Array.from(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(lodash_1.default.map(dashboardResultDataArray, value => Array.from(value.chunkData.newUsers.data))))
                            };
                            const resultProjectUsers = lodash_1.default.sumBy(dashboardResultDataArray, value => value.chunkData.projectUsers);
                            const dashboardResult = {
                                ok: {
                                    dau: resultDau,
                                    wau: resultWau,
                                    mau: resultMau,
                                    newUsers: resultNewUsers,
                                    projectUsers: resultProjectUsers
                                }
                            };
                            if (!!process.env.IS_TEST_SERVER) {
                                console.log("getDashboardResultByChunks dashboardResult", dashboardResult);
                            }
                            resolve(dashboardResult);
                            return;
                        }
                        else {
                            console.warn("getDashboardResultByChunks promises failure: no success results", dashboardResultDataArray);
                            resolve({ err: { "temporarilyUnavailable": null } });
                            return;
                        }
                    }
                }
                catch (e) {
                    console.warn("getDashboardResultByChunks failed", e);
                    resolve({ err: { "temporarilyUnavailable": null } });
                    return;
                }
            }
        });
    });
};
exports.getProjectDashboardResultByChunks = getProjectDashboardResultByChunks;
